import { IActiveBannerListReq } from '@models/interfaces/microservice/cms.interface';
import CMSService from '@services/microservices/cms.service';
import { useQuery } from '@tanstack/react-query';

export const useActiveListBanner = (props: IActiveBannerListReq) => {
  return useQuery({
    queryKey: ['activeListBanner', props.page, props.markets],
    queryFn: async () => {
      const rawData = await CMSService.get_active_banner_list(props);
      return rawData.data;
    },
    enabled: props.markets.length > 0,
  });
};
